import { render, staticRenderFns } from "./FormRaci.vue?vue&type=template&id=c198f12c&scoped=true"
import script from "./FormRaci.vue?vue&type=script&lang=js"
export * from "./FormRaci.vue?vue&type=script&lang=js"
import style0 from "./FormRaci.vue?vue&type=style&index=0&id=c198f12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c198f12c",
  null
  
)

export default component.exports